import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	dropdownMenu: {
		fontSize: '0.875rem',
	},
	dropdownTrigger: {
		background: '#fff',
		color: '#858585',
		fontSize: 14,
		width: 180,
		borderRadius: 6,
	},
});
